import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
import DesktopSidebar from '../components/DesktopSidebar';
import DesktopRightPanel from '../components/DesktopRightPanel';

const DesktopLayout: React.FC = () => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

    if (!isDesktop) {
        return <Outlet />;
    }

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh', gap: 2, p: 2, bgcolor: 'background.default' }}>
            {/* Left Sidebar */}
            <DesktopSidebar />

            {/* Center Content */}
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Outlet />
            </Box>

            {/* Right Sidebar */}
            <DesktopRightPanel />
        </Box>
    );
};

export default DesktopLayout;